import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/** Rutas no reconocidas: llevan a la home en lugar del swap. */
export function RedirectToHome() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/', search: location.search, hash: location.hash }} replace />
}
